import React, { useState, useEffect } from 'react';
import './sai100gal.css';


function Sai100Gal() {
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [imagesUrls, setImagesUrls] = useState([]);
    const AWS = require('aws-sdk');
    const KEY_PREFIX = 'sai100mke'; // S3 key prefix where images are stored (folder in bucket)
    
    // Array of all sai100 image filenames (kept as keys in S3 under "sai100/")
    const images = [
        'DSC_0449.jpg', 'DSC_0451.jpg', 'DSC_0457.jpg', 'DSC_0459.jpg', 'DSC_0461.jpg',
        'DSC_0464.jpg', 'DSC_0465.jpg',  'DSC_0468.jpg', 'DSC_0469.jpg',
        'DSC_0470.jpg',  'DSC_0473.jpg', 'DSC_0474.jpg', 'DSC_0476.jpg',
        'DSC_0477.jpg', 'DSC_0478.jpg', 'DSC_0479.jpg', 'DSC_0481.jpg', 'DSC_0483.jpg',
        'DSC_0485.jpg', 'DSC_0486.jpg', 'DSC_0487.jpg', 'DSC_0488.jpg', 'DSC_0489.jpg',
        'DSC_0490.jpg', 'DSC_0491.jpg', 'DSC_0492-2-2.jpg', 'DSC_0492-2.jpg', 'DSC_0492.jpg',
        'DSC_0493.jpg', 'DSC_0494.jpg', 'DSC_0495.jpg', 'DSC_0497.jpg', 'DSC_0498.jpg',
        'DSC_0499.jpg', 'DSC_0500.jpg', 'DSC_0501.jpg', 'DSC_0504.jpg', 'DSC_0507.jpg',
        'DSC_0508.jpg', 'DSC_0510.jpg', 'DSC_0513-2.jpg', 'DSC_0513-3.jpg', 'DSC_0513.jpg',
        'DSC_0516.jpg', 'DSC_0521.jpg', 'DSC_0524.jpg', 'DSC_0526.jpg', 'DSC_0529.jpg',
        'DSC_0530.jpg', 'DSC_0531.jpg', 'DSC_0532.jpg', 'DSC_0533.jpg', 'DSC_0535.jpg',
        'DSC_0539.jpg', 'DSC_0540.jpg', 'DSC_0541.jpg', 'DSC_0542-2-2.jpg', 'DSC_0542-2-3.jpg',
        'DSC_0542-2.jpg', 'DSC_0542.jpg', 'DSC_0544.jpg', 'DSC_0546.jpg', 'DSC_0550.jpg',
        'DSC_0551.jpg', 'DSC_0552.jpg', 'DSC_0553.jpg', 'DSC_0554.jpg', 'DSC_0555.jpg',
        'DSC_0556.jpg', 'DSC_0557.jpg', 'DSC_0560.jpg', 'DSC_0561.jpg', 'DSC_0562.jpg',
        'DSC_0563.jpg', 'DSC_0565.jpg', 'DSC_0566.jpg', 'DSC_0567.jpg', 'DSC_0569.jpg',
        'DSC_0571.jpg', 'DSC_0573.jpg', 'DSC_0576.jpg', 'DSC_0577.jpg', 'DSC_0578.jpg',
        'DSC_0579.jpg', 'DSC_0582.jpg', 'DSC_0583.jpg', 'DSC_0584.jpg', 'DSC_0586.jpg',
        'DSC_0587.jpg', 'DSC_0588.jpg', 'DSC_0589.jpg', 'DSC_0590.jpg', 'DSC_0591.jpg',
        'DSC_0592.jpg', 'DSC_0595.jpg', 'DSC_0601.jpg', 'DSC_0602.jpg', 'DSC_0604.jpg',
        'DSC_0607.jpg', 'DSC_0608.jpg', 'DSC_0610.jpg', 'DSC_0613.jpg', 'DSC_0626.jpg',
        'DSC_0632.jpg', 'DSC_0640.jpg', 'DSC_0644.jpg', 'DSC_0645.jpg', 'DSC_0646.jpg',
        'DSC_0647.jpg', 'DSC_0648.jpg', 'DSC_0649.jpg', 'DSC_0650.jpg', 'DSC_0651.jpg',
        'DSC_0653.jpg', 'DSC_0656.jpg', 'DSC_0657.jpg', 'DSC_0658.jpg', 'DSC_0659.jpg',
        'DSC_0660.jpg', 'DSC_0661.jpg', 'DSC_0662.jpg', 'DSC_0663.jpg', 'DSC_0664.jpg',
        'DSC_0666.jpg', 'DSC_0667.jpg', 'DSC_0668.jpg', 'DSC_0669.jpg', 'DSC_0670.jpg',
        'DSC_0671.jpg', 'DSC_0673.jpg', 'DSC_0674.jpg', 'DSC_0676.jpg', 'DSC_0678.jpg',
        'DSC_0679.jpg', 'DSC_0680.jpg', 'DSC_0681.jpg', 'DSC_0682-2.jpg', 'DSC_0682.jpg',
        'DSC_0685.jpg', 'DSC_0687.jpg', 'DSC_0688.jpg', 'DSC_0690.jpg', 'DSC_0692.jpg',
        'DSC_0693.jpg', 'DSC_0694.jpg', 'DSC_0695.jpg', 'DSC_0696.jpg', 'DSC_0697.jpg',
        'DSC_0698.jpg', 'DSC_0699.jpg', 'DSC_0700.jpg', 'DSC_0701.jpg', 'DSC_0702.jpg',
        'DSC_0703.jpg', 'DSC_0706.jpg', 'DSC_0707.jpg', 'DSC_0713.jpg', 'DSC_0714.jpg',
        'DSC_0716.jpg', 'DSC_0718.jpg', 'DSC_0719.jpg', 'DSC_0720.jpg', 'DSC_0722.jpg',
        'DSC_0726.jpg', 'DSC_0727.jpg', 'DSC_0729.jpg', 'DSC_0730.jpg', 'DSC_0735.jpg',
        'DSC_0736.jpg', 'DSC_0738.jpg', 'DSC_0739.jpg', 'DSC_0740.jpg', 'DSC_0741.jpg',
        'DSC_0743.jpg', 'DSC_0746.jpg', 'DSC_0747.jpg', 'DSC_0748.jpg', 'DSC_0749.jpg',
        'DSC_0750-2.jpg', 'DSC_0750.jpg', 'DSC_0752.jpg', 'DSC_0754.jpg', 'DSC_0755.jpg',
        'DSC_0756.jpg', 'DSC_0757.jpg', 'DSC_0758.jpg', 'DSC_0759.jpg', 'DSC_0760.jpg',
        'DSC_0762.jpg', 'DSC_0763.jpg', 'DSC_0764.jpg', 'DSC_0765.jpg', 'DSC_0766.jpg',
        'DSC_0768.jpg', 'DSC_0769.jpg', 'DSC_0771.jpg', 'DSC_0772.jpg', 'DSC_0773.jpg',
        'DSC_0774.jpg', 'DSC_0775.jpg', 'DSC_0776.jpg', 'DSC_0777.jpg', 'DSC_0778.jpg',
        'DSC_0779.jpg', 'DSC_0780.jpg', 'DSC_0781.jpg', 'DSC_0782.jpg', 'DSC_0783.jpg',
        'DSC_0784.jpg', 'DSC_0785.jpg', 'DSC_0786.jpg', 'DSC_0787.jpg', 'DSC_0788.jpg',
        'DSC_0789.jpg', 'DSC_0790.jpg', 'DSC_0791.jpg', 'DSC_0793.jpg', 'DSC_0796-2.jpg',
        'DSC_0796.jpg', 'DSC_0799.jpg', 'DSC_0800.jpg', 'DSC_0801.jpg', 'DSC_0802.jpg',
        'DSC_0806.jpg', 'DSC_0811.jpg', 'DSC_0812.jpg', 'DSC_0813.jpg', 'DSC_0814.jpg',
        'DSC_0815.jpg', 'DSC_0816.jpg', 'DSC_0817.jpg', 'DSC_0819.jpg', 'DSC_0821.jpg',
        'DSC_0822.jpg', 'DSC_0824.jpg', 'DSC_0825.jpg', 'DSC_0827.jpg', 'DSC_0830.jpg',
        'DSC_0831.jpg', 'DSC_0832.jpg', 'DSC_0833.jpg', 'DSC_0834.jpg', 'DSC_0835.jpg',
        'DSC_0836-2.jpg', 'DSC_0836-3.jpg', 'DSC_0836.jpg', 'DSC_0837.jpg', 'DSC_0838.jpg',
        'DSC_0839.jpg', 'DSC_0841.jpg', 'DSC_0842.jpg', 'DSC_0843.jpg', 'DSC_0845.jpg',
        'DSC_0846.jpg', 'DSC_0847.jpg', 'DSC_0848.jpg', 'DSC_0850.jpg', 'DSC_0851.jpg',
        'DSC_0852.jpg', 'DSC_0853.jpg', 'DSC_0854.jpg', 'DSC_0855.jpg', 'DSC_0856.jpg',
        'DSC_0857.jpg', 'DSC_0858.jpg', 'DSC_0859.jpg', 'DSC_0860.jpg', 'DSC_0861-2.jpg',
        'DSC_0861.jpg', 'DSC_0862.jpg', 'DSC_0863.jpg', 'DSC_0864.jpg', 'DSC_0866-2.jpg',
        'DSC_0866.jpg', 'DSC_0868.jpg', 'DSC_0869.jpg', 'DSC_0870.jpg', 'DSC_0871.jpg',
        'DSC_0872.jpg', 'DSC_0874.jpg', 'DSC_0875.jpg', 'DSC_0876.jpg', 'DSC_0878.jpg',
        'DSC_0879.jpg', 'DSC_0880.jpg', 'DSC_0881.jpg', 'DSC_0886.jpg', 'DSC_0887.jpg',
        'DSC_0892.jpg', 'DSC_0893.jpg', 'DSC_0894.jpg', 'DSC_0895.jpg', 'DSC_0896.jpg',
        'DSC_0897.jpg', 'DSC_0898.jpg', 'DSC_0899.jpg', 'DSC_0900.jpg', 'DSC_0901.jpg',
        'DSC_0902.jpg', 'DSC_0903.jpg', 'DSC_0904.jpg'
    ];

    AWS.config.update({
        region: 'us-east-1',
        accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
        secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY});

    let s3 = new AWS.S3();

    useEffect(() => {
        let mounted = true;

        const loadFromS3 = async () => {
            const urls = await Promise.all(images.map(async (filename) => {
                const key = `${filename}`;
                try {
                    const url = await s3.getSignedUrlPromise('getObject', {
                        Bucket: process.env.REACT_APP_AWS_USER_FILES_S3_BUCKET,
                        Key: key,
                        Expires: 60 * 60 // URL valid for 1 hour
                    });
                    return url;
                } catch (err) {
                    console.error(`Error fetching ${key} from S3:`, err);
                    return null; // Return null for failed images
                }
            }));

            if (mounted) setImagesUrls(urls);
        };

        loadFromS3();

        return () => { mounted = false; };
    }, []);

    const handleImageClick = (index) => {
        setSelectedIndex(index);
    };

    const prevImage = (e) => {
        if (e) e.stopPropagation();
        if (selectedIndex === null) return;
        const prevIdx = (selectedIndex - 1 + images.length) % images.length;
        setSelectedIndex(prevIdx);
    };

    const nextImage = (e) => {
        if (e) e.stopPropagation();
        if (selectedIndex === null) return;
        const nextIdx = (selectedIndex + 1) % images.length;
        setSelectedIndex(nextIdx);
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (selectedIndex === null) return;
            if (e.key === 'ArrowLeft') prevImage();
            if (e.key === 'ArrowRight') nextImage();
            if (e.key === 'Escape') closeModal();
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [selectedIndex]);

    const closeModal = () => {
        setSelectedIndex(null);
    };

    const handleModalBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            closeModal();
        }
    };

    return (
        <>
            <section id="gallery-379">
            <div className="cs-container">
                <div className="cs-content">
                    <span className="cs-topper">Our Offering</span>
                    <h2 className="cs-title">With Deepest Love for Bhagawan Sri Sathya Sai</h2>
                </div>
                <div className="cs-gallery">
                    {images.map((image, index) => (
                        imagesUrls[index] ? (
                            <picture key={index} className="cs-image" onClick={() => handleImageClick(index)}>
                                <source media="(max-width: 600px)" srcSet={imagesUrls[index]}></source>
                                <source media="(min-width: 601px)" srcSet={imagesUrls[index]}></source>
                                <img loading="lazy" decoding="async" src={imagesUrls[index]} alt={`gallery ${index + 1}`} width="305" height="400"></img>
                            </picture>
                        ) : (
                            <div key={index} className="cs-image cs-image--unavailable" aria-hidden="true">Cannot display image</div>
                        )
                    ))}
                </div>
            </div>
        </section>

            {/* Modal */}
            {selectedIndex !== null && (
                <div className="cs-modal-backdrop" onClick={handleModalBackdropClick}>
                    <div className="cs-modal-content">
                        <button className="cs-modal-close" onClick={closeModal}>×</button>
                        <button className="cs-modal-nav cs-modal-nav--left" aria-label="Previous image" onClick={prevImage}>&larr;</button>
                        {imagesUrls[selectedIndex] ? (
                            <img src={imagesUrls[selectedIndex]} alt="gallery modal" className="cs-modal-image"></img>
                        ) : (
                            <div className="cs-modal-noimage">Cannot display image</div>
                        )}
                        <button className="cs-modal-nav cs-modal-nav--right" aria-label="Next image" onClick={nextImage}>&rarr;</button>
                        <div className="cs-modal-caption">{selectedIndex + 1} / {images.length}</div>
                    </div>
                </div>
            )}
        </>
    );
}

export default Sai100Gal;
